import script from "./Page6.vue?vue&type=script&setup=true&lang=js"
export * from "./Page6.vue?vue&type=script&setup=true&lang=js"

import "./Page6.vue?vue&type=style&index=0&id=12731866&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12731866"]])

export default __exports__